module.exports = __webpack_public_path__ + "src/assets/textures/env/barn/outside_barn_bake_2k.png";